module.exports = __webpack_public_path__ + "static/media/riviera.2cbf2929.jpg";